module.exports = __webpack_public_path__ + "static/img/link4.428d5cc8.png";